// extracted by mini-css-extract-plugin
module.exports = {"productList":"ProductList_productList__2yGgS","items":"ProductList_items__2VhfC"};